import { Layout } from '../../layout'
import { ChartGrowthRate } from './chartGrowthRate'
import { ChartIndustry } from './chartIndustry'

export const GdpChart = () => {
  return (
    <Layout>
      <ChartGrowthRate />
      <ChartIndustry />
    </Layout>
  )
}
